<script setup lang="tsx">
import store from '@/stores/slider'
import { computed, nextTick, onBeforeMount } from 'vue'
import { useI18n } from 'vue-i18n'
import Modal from '../shared/Modal.vue'

const { t } = useI18n()
const slider = store()

const cls = computed(() => {
	return {
		open: slider.isVisible,
	}
})

onBeforeMount(() => {
	document.addEventListener('click', (e) => {
		if (slider.isVisible) {
			const el = e.target as HTMLElement

			const insideBody = el.closest('body')
			if (!insideBody) return

			const insideSlider = el.closest('.slider')
			const insideModal = el.closest('.modal')
			const insideToast = el.closest('.toast-container')

			if (!insideSlider && !insideModal && !insideToast) {
				if (slider.getHasUnsavedChanges()) {
					showModal.value = true
					return
				}
				nextTick(() => (slider.isVisible = false))
			}
		}
	})
})

const showModal = computed({
	get: () => slider.showUnsavedChangesModal,
	set: (val) => (slider.showUnsavedChangesModal = val),
})
</script>

<template>
	<div class="slider d-flex flex-column" :class="cls">
		<div class="p-3 d-inline-flex justify-content-between header">
			<h2>{{ slider.title }}</h2>
			<button class="btn btn-default rounded-circle align-self-center" @click="slider.isVisible = false">
				<i class="bi bi-x"></i>
			</button>
		</div>
		<div class="p-3 flex-grow-1 content">
			<component v-if="slider.isVisible" :is="slider.getComponent()"></component>
		</div>
		<component v-if="slider.isVisible" :is="slider.getFooter()" class="m-3"></component>
	</div>
	<Modal v-model="showModal" @confirm="slider.confirmCancel" @cancel="slider.cancelCancel" :type="slider.confirmDeleteModal.type">
		<template #header>{{ t('misc.unsavedChanges') }}</template>
		<template #body>{{ t('misc.discard') }}</template>
		<template #footer>
			<button data-test="keep-changes" type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="slider.cancelCancel()">
				{{ $t('misc.keep') }}
			</button>
			<button data-test="leave-page" type="button" class="btn btn-primary" @click="slider.confirmCancel()">
				{{ $t('misc.leave') }}
			</button>
		</template>
	</Modal>
	<Modal
		v-if="slider.confirmDeleteModal"
		v-model="slider.confirmDeleteModal.show"
		@confirm="slider.confirmDelete"
		@cancel="slider.cancelConfirmDelete"
		:type="slider.confirmDeleteModal.type"
	>
		<template #header>{{ t('misc.delete') }}</template>
		<template #body>{{ slider.confirmDeleteModal.message }}</template>
	</Modal>
</template>

<style lang="sass" scoped>
.slider
    z-index: 1050
    padding: 0
    position: fixed
    right: 0
    width: 0
    height: 100vh
    background-color: var(--bs-body-bg)
    color: var(--bs-body-color)
    border-left: 1px solid var(--bs-border-color)
    transition: width .2s ease-in-out

.open
    width: 40em

.header
    border-bottom: 1px solid var(--bs-border-color)
    background-color: var(--bs-secondary-bg)

.header > h2
    margin: 0

.content
    overflow-y: scroll
</style>
